<template>
<div id="LoginIndex">
    <header class="login-header">
        <img src="../assets/img/header-logo.png" alt class="header-img" />
        <div class="header-item">
            <el-button class="lang-switch" type="text" @click="handleLangSwitch">
                <i class="icon" :class="$i18n.locale=='zh' ? 'i-zh_to_en' : 'i-en_to_zh'"/>
            </el-button>
        </div>
    </header>
    <div class="login-form-container">
        <div class="login-form-panel">
            <div class="panel-header">
                <div class="type-item" :class="{'active': currType === TYPE.ADMIN}" @click="handleLoginTypeChange(TYPE.ADMIN)">{{$t(/*管理员*/'user.admin')}}</div>
                <div class="type-item" :class="{'active': currType === TYPE.CLIENT}" @click="handleLoginTypeChange(TYPE.CLIENT)">{{$t(/*普通用户*/'user.client')}}</div>
            </div>
            <div class="panel-body">
                <el-input class="input-item" v-model="loginForm.username" :placeholder="$t(/*用户名*/'user.username')"/>
                <el-input class="input-item" v-model="loginForm.password" :placeholder="$t(/*密码*/'user.password')" @keyup.enter.native="handleLogin" type="password"/>
                <el-button type="primary" class="login-btn" @click="handleLogin">{{$t(/*登录*/'c.login')}}</el-button>
            </div>
        </div>
    </div>
    <!-- <div class="login-footer">Copyright © 2021 江苏浩万智能科技有限公司 浙ICP备09093915号</div> -->
</div>
</template>


<script>
import Core from '../core'

const TYPE = Core.Const.USER.TYPE

export default {
    data() {
        return {
            TYPE,
            currType: TYPE.ADMIN,

            loginForm: {
                username: '',
                password: ''
            },
        }
    },
    mounted() {
        let currType = Core.Data.getUserType()
        console.log('mounted currType:', currType)
        if (currType) {
            this.currType = currType
        } else {
            this.handleLoginTypeChange(TYPE.ADMIN)
        }
    },
    methods: {
        handleLoginTypeChange(type) {
            this.currType = type
            Core.Data.setUserType(type)
        },
        handleLogin() {
            let f = Core.Util.deepCopy(this.loginForm)

            if (!f.username) {
                return this.$message.warning(this.$t(/*请输入*/'c.input')+this.$t(/*用户名*/'user.username'))
            }
            if (!f.password) {
                return this.$message.warning(this.$t(/*请输入*/'c.input')+this.$t(/*密码*/'user.password'))
            }

            let apiName = this.currType === TYPE.ADMIN ? 'Admin' : "User"
            console.log('handleLogin apiName:', apiName)
            Core.Api[apiName].login(f).then(res => {
                Core.Data.setUserType(this.currType)
                Core.Data.setToken(res.token)
                let authMap = {}
                if (this.currType === TYPE.ADMIN) {
                    Core.Data.setUser(res.admin)
                    authMap['ADMIN'] = true
                } else {
                    Core.Data.setUser(res.user)
                    authMap['CLIENT'] = true
                }
                Core.Data.setAuthority(authMap)

                if (this.currType === TYPE.ADMIN && res.admin.config) {
                    let arr = []
                    try {
                        arr = JSON.parse(res.admin.config)
                    } catch (error) {}
                    if (arr.length) {
                        return this.$router.push({ name: arr[0] })
                    }
                }
                this.$router.push('/home')
            })
        },
        // 中英文切换
        handleLangSwitch() {
            console.log('handleLangSwitch', this.$i18n)
            this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh'
            Core.Data.setLanguage(this.$i18n.locale)
        },
    }
}
</script>

<style lang="scss">
#LoginIndex {
    height: 100vh;
    width: 100%;
    background: #f3f6fa;
    position: relative;
    .login-header {
        position: absolute;
        top: 0;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0 20px;
        @include fsb();
        .header-img {
            height: 25px;
            width: 125px;
        }
        .header-item {
            height: 100%;
            width: 40px;
            font-size: 20px;
            @include fcc();
        }
        .lang-switch {
            color: #34383E;
            &:hover { color: #155BD4; }
            .icon {
                font-size: 20px;
            }
        }
    }
    .login-form-container {
        width: 100%;
        height: 100%;
        padding: 60px 0;
        margin: 0 auto;
        @include fcc();
        .login-form-panel {
            margin: 0 auto;
            background: #ffffff;
            border-radius: 4px;
            overflow: auto;
            width: 412px;
            border: 1px solid #dce2e8;
            .panel-header {
                display: flex;
                height: 60px;
                cursor: pointer;
                .type-item {
                    flex: 1;
                    @include fcc();
                    height: 60px;
                    box-sizing: border-box;
                    background-color: #f6f9fc;
                    color: #363d42;
                    font-size: 16px;
                    font-weight: 500;
                    border-bottom: 1px solid #dce2e8;
                    line-height: 22px;
                    + .type-item {
                        border-left: 1px solid #dce2e8;
                    }

                    &.active {
                        background-color: #fff;
                        border-bottom-color: #fff;
                        color: #155bd4;
                    }
                }
            }
            .panel-body {
                padding: 40px 30px;
                @include flex();
                .input-item {
                    width: 100%;
                    height: 46px;
                    margin: 0 auto;
                    &:first-child {
                        margin-bottom: 16px;
                    }
                    .el-input__inner {
                        height: 46px;
                    }
                }
                .login-btn {
                    width: 100%;
                    height: 40px;
                    margin-top: 30px;
                    font-size: 14px;
                    color: #fff;
                    @include fcc();
                }
            }
        }
    }
    .login-footer {
        width: 100%;
        position: absolute;
        bottom: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #373b41;
        line-height: 20px;
        white-space: nowrap;
        text-align: center;
    }
}
</style>
